//   链猫秒杀
export default [{
  path: '/chainCatSpike',
  name: 'chainCatSpike',
  meta: {
    index: 2
  },
  component: () => import('@/views/chainCatSpike/index')
}]
